export const MOCK_STORE_OPTIONS = [
  { _id: 'store-1', name: 'Rev & Bolt — eBay US' },
  { _id: 'store-2', name: 'Rev & Bolt — eBay CA' },
];

export const PROCESS_STEPS = [
  {
    id: 'scope',
    label: 'Resolve partslink scope',
    description: 'Load partslinks from CSV upload or manual list',
  },
  {
    id: 'mapping',
    label: 'Load supplier SKU → Partslink mapping',
    description: 'Resolve supplier SKU for each partslink in scope',
  },
  {
    id: 'browse',
    label: 'Browse eBay search results',
    description: 'Search eBay Browse API using each partslink',
  },
  {
    id: 'validate',
    label: 'Validate verified seller match',
    description: 'Find the carpartswholesale listing in search results',
  },
  {
    id: 'fetch',
    label: 'Fetch reference listing data',
    description: 'Pull title, images, item specifics, and fitment from matched listing',
  },
  {
    id: 'compile',
    label: 'Compile listing from rules',
    description: 'Apply listing fields configuration and build catalog payload',
  },
  {
    id: 'publish',
    label: 'Save catalog & push to marketplace',
    description: 'Persist SKU catalog and create or revise linked marketplace listing',
  },
];

export const MOCK_MAPPING_PREVIEW = [
  { sku: 'CPW-HO123', partslink: 'HO123456' },
  { sku: 'CPW-FO456', partslink: 'FO456789' },
  { sku: 'CPW-GM789', partslink: 'GM789012' },
];
